import { ServerSideLogger } from './ServerSideLogger'
import { ClientSideLogger } from './ClientSideLogger'
import { Logger } from './types'

const shouldCollectAnalytics = process.env.NODE_ENV === 'production'

let logger: Logger
if (typeof window !== 'undefined') {
  // Check if we're running in the browser.
  logger = new ClientSideLogger(shouldCollectAnalytics)
} else {
  logger = new ServerSideLogger()
}

export { logger }
